var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z",
    fill: "#005a92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarBlue);
export default __webpack_public_path__ + "static/media/chart-bar-blue.c65b1fe46489d631c62b3753fdc89934.svg";
export { ForwardRef as ReactComponent };